// Configuration file for promo banners and site settings
// Edit this file to enable/disable promos and update dates

export const siteConfig = {
  // Contact email
  email: "gilles@centre-terre-ciel.com",
  
  // Main CTA link
  mainCTALink: "https://gillesdelieuze.com/bdc-ecole-maitres-dauphins/",
  
  // Therapist page link
  therapistLink: "https://gillesdelieuze.com/cursus-therapeutes-ecole-dauphins/",
  
  // RDV Clarity page
  rdvClarityLink: "https://gillesdelieuze.com/rdv-clarte-2/",
  
  // Legal links
  privacyLink: "https://gillesdelieuze.com/politique-de-confidentialite/",
  termsLink: "https://gillesdelieuze.com/conditions-de-generales-vente/",
  legalLink: "https://gillesdelieuze.com/mentions-legales",
  
  // Promo configuration
  promo: {
    // Set to true to show promo banners, false to hide them
    enabled: true,
    
    // Promo dates (format: DD/MM/YYYY)
    startDate: "25/01/2026",
    endDate: "01/02/2026",
    endTime: "23H59",
    
    // Maximum discount
    maxDiscount: "-30%",
    
    // Pricing
    pricing: {
      classic: {
        originalPrice: 2222,
        payments: [
          { times: 1, discount: 30, label: "1x" },
          { times: 2, discount: 25, label: "2x" },
          { times: 3, discount: 20, label: "3x" },
          { times: 5, discount: 20, label: "5x" },
          { times: 10, discount: 18, label: "10x" },
          { times: 12, discount: 15, label: "12x" },
          { times: 16, discount: 10, label: "16x" },
        ]
      },
      vip: {
        originalPrice: 3333,
        payments: [
          { times: 1, discount: 30, label: "1x" },
          { times: 2, discount: 25, label: "2x" },
          { times: 3, discount: 20, label: "3x" },
        ]
      }
    }
  }
};

// Helper function to calculate discounted price
export const getDiscountedPrice = (originalPrice, discountPercent) => {
  return Math.round(originalPrice * (1 - discountPercent / 100));
};

// Helper function to format promo text
export const getPromoText = () => {
  const { startDate, endDate, endTime, maxDiscount } = siteConfig.promo;
  return `PROMO DU ${startDate.split('/').slice(0, 2).join('/')} AU ${endDate} À ${endTime} • ${maxDiscount}`;
};

export const getPromoDateRange = () => {
  const { startDate, endDate, endTime } = siteConfig.promo;
  return `DU ${startDate.split('/').slice(0, 2).join('/')}/${startDate.split('/')[2].slice(2)} AU ${endDate.split('/').slice(0, 2).join('/')}/${endDate.split('/')[2]} À ${endTime}`;
};

export default siteConfig;
